// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { spSelectTag } from "#/admin/legacy/sp-select/index.js";

/** Returns the next question picker's template context: the action items, then a row per `{ id, title }` question. */
export function nextQuestionSelectContext(attributes, actionItems, questions) {
  const nextQuestionItems = actionItems.concat(questions.map(questionItem));

  return {
    ...attributes,
    sp_select_tag: spSelectTag,
    nextQuestionItems,
  };
}

function questionItem(question) {
  return {
    title: question.title,
    value: String(question.id),
    dataset: {},
  };
}
